import axios from 'axios'
import { Modal, Button } from 'react-bootstrap'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import { useEffect, useState } from 'react'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'

export default function DeleteEnrolledCourse({
  show,
  onHide,
  onConfirm,
  studentId,
  studentName,
  courseName,
  courseId,
}) {
  const [blinkColor, setBlinkColor] = useState('red')

  useEffect(() => {
    const interval = setInterval(() => {
      setBlinkColor((prevColor) => (prevColor === 'red' ? 'blue' : 'red'))
    }, 500)

    return () => clearInterval(interval) // cleanup
  }, [])

  // console.log('STUDENT NAME:', studentName)
  const handleConfirmDelete = async () => {
    try {
      const instituteId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null

      console.log('InstituteID:', instituteId)

      if (userCookie) {
        try {
          const user = JSON.parse(userCookie)
          token = user.token
          console.log('TOKEN:', token)
          // Optional: setUser(user); // if you're using state to store user
        } catch (err) {
          console.error('Failed to parse user cookie', err)
          toast.error('Authentication error. Please login again.')
          return
        }
      } else {
        console.warn('User cookie not found')
        toast.error('User not found. Please login again.')
        return
      }

      // or get it from cookies/context
      const response = await axios.delete(
        BASE_URL+'/student-course',
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          data: {
            student_id: studentId,
            course_id: courseId,
          },
        },
      )

      //   console.log('Deleted Successfully:', response.data)
      toast.success(response.data.message)
      if (onConfirm) onConfirm()
      onHide()
      // Optional: refresh data or show success toast here
    } catch (error) {
      console.error('Delete failed:', error.response?.data || error.message)
      toast.error(error.response?.data?.message)
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className="bg-white text-white" closeButton>
        <Modal.Title style={{ letterSpacing: '1px' }}>
          <h3 className="text-danger fw-bold"> Confirm Course Deletion</h3>{' '}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2 fw-semibold" style={{ letterSpacing: '2px' }}>
          Are you sure you want to delete the enrolled course{' '}
          <strong>{courseName}</strong> for Student{' '}
          <strong>{studentName}</strong>?<br />
          <hr />
          <div
            // className="mt-3 text-muted fw-semibold"
            style={{
              color: blinkColor,
              marginTop: '12px',
              marginBottom: '10px',
              fontWeight: '600',
              letterSpacing: '2px',
            }}
          >
            This action is irreversible and the course will be permanently
            removed.
          </div>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirmDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
